import r, { memo as I, useMemo as i } from "react";
import { Icon as _ } from "../icon/icon.js";
import "@loadable/component";
import { useTheme as l, useBreakpointValue as M, Flex as P, Text as V } from "@chakra-ui/react";
import "@chakra-ui/system";
import { getTypography as j } from "../../../utils/typographyUtils.js";
import { isBrowser as A } from "../../../utils/commonUtils.js";
const F = I(
  ({
    leftIcon: a,
    alignment: u,
    children: d,
    color: g,
    paragraphStyle: m = "regular",
    size: e = 1,
    weight: t = "regular",
    marginBottom: h,
    mb: b
  }) => {
    const {
      common: f,
      element: o,
      button: n,
      alertsInteriorSpacing: x,
      text: {
        deemphasized: T,
        accent3: y,
        default: k
      }
    } = l(), c = l(), C = {
      base: `mobile0${e}`,
      sm: `tablet0${e}`,
      lg: `desktop0${e}`
    }, p = M(C, {
      ssr: !A(),
      fallback: "base"
    }), $ = i(() => {
      const E = t.charAt(0).toUpperCase() + t.slice(1);
      return f[`common0${e}${E}`];
    }, [e, t]), B = i(() => j(p, c), [p, c]), s = {
      regular: k,
      deemphasized: T,
      accent: y
    };
    return /* @__PURE__ */ r.createElement(
      P,
      {
        justifyContent: u,
        marginBottom: (h || b) ?? (o == null ? void 0 : o.spacingMedium),
        gap: x
      },
      a && /* @__PURE__ */ r.createElement(
        _,
        {
          as: a,
          color: s[m],
          w: n.mediumIcon,
          h: n.mediumIcon,
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ r.createElement(
        V,
        {
          "data-testid": "sub-heading",
          color: g ?? s[m],
          ...$,
          ...B
        },
        d
      )
    );
  }
);
F.displayName = "Heading_Paragraph";
export {
  F as Paragraph
};
